import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#00bcd4', // Cyan
      light: '#4dd0e1',
      dark: '#0097a7',
    },
    secondary: {
      main: '#ff4081',
      light: '#ff77b4',
      dark: '#c60055',
    },
    background: {
      default: `url('/background.webp') no-repeat center center / cover`,
      paper: '#1a1f3a',
    },
    text: {
      primary: '#ffffff',
      secondary: '#b0bec5',
    },
    divider: '#37474f',
  },
  typography: {
    fontFamily: '"Segoe UI", "Helvetica Neue", "Arial", sans-serif',
    h1: {
      fontSize: '3.5rem',
      fontWeight: 700,
      letterSpacing: '-1.5px',
      marginBottom: '1rem',
    },
    h2: {
      fontSize: '2.5rem',
      fontWeight: 600,
      letterSpacing: '-0.5px',
      marginBottom: '1.5rem',
    },
    h3: {
      fontSize: '2rem',
      fontWeight: 600,
      marginBottom: '1rem',
    },
    h4: {
      fontSize: '1.5rem',
      fontWeight: 600,
    },
    h5: {
      fontSize: '1.25rem',
      fontWeight: 500,
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 500,
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.6,
    },
    body2: {
      fontSize: '0.9rem',
      lineHeight: 1.5,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
          borderRadius: '8px',
          padding: '10px 24px',
          transition: 'all 0.3s ease',
        },
        contained: {
          background: 'linear-gradient(135deg, #00bcd4 0%, #0097a7 100%)',
          '&:hover': {
            background: 'linear-gradient(135deg, #4dd0e1 0%, #00bcd4 100%)',
            boxShadow: '0 8px 16px rgba(0, 188, 212, 0.3)',
          },
        },
        outlined: {
          borderColor: '#00bcd4',
          color: '#00bcd4',
          '&:hover': {
            backgroundColor: 'rgba(0, 188, 212, 0.1)',
            borderColor: '#4dd0e1',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: '#1a1f3a',
          borderRadius: '12px',
          border: '1px solid #37474f',
          transition: 'all 0.3s ease',
          '&:hover': {
            boxShadow: '0 12px 30px rgba(0, 188, 212, 0.2)',
            borderColor: '#00bcd4',
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: 'rgba(10, 14, 39, 0.95)',
          backdropFilter: 'blur(10px)',
          borderBottom: '1px solid #37474f',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            color: '#ffffff',
            '& fieldset': {
              borderColor: '#37474f',
            },
            '&:hover fieldset': {
              borderColor: '#00bcd4',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#00bcd4',
            },
          },
          '& .MuiInputBase-input::placeholder': {
            color: '#b0bec5',
            opacity: 1,
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          backgroundColor: 'rgba(0, 188, 212, 0.15)',
          borderColor: '#00bcd4',
          color: '#4dd0e1',
          fontWeight: 500,
        },
      },
    },
  },
  shape: {
    borderRadius: 12,
  },
});

export default theme;
